import {RewardType} from "@/Core/Reward/RewardInfo";
import UserMgr from "@/Core/UserMgr";

export class SRewardPresenter {
    static Instance: SRewardPresenter = new SRewardPresenter();

    static get gcCount(): number {
        return UserMgr.gcCount;
    } // 示例值

    static get scCountAtom(): number {
        return UserMgr.scCountAmount;
    }

    //todo 可兑换上限  需要后端返回值
    static get scAvailableToRedeem(): number {

        return 25;
    } // 示例值


}
